/**
 * Datentypen der Rechnungs-Eigenschaften — Ersatz für
 * `typeof(Receipt).GetProperty(FieldName).PropertyType`.
 *
 * Die Reihenfolge der Schlüssel bestimmt die Feldliste (`receiptFieldNames`).
 */

import type { Receipt } from '../entities';
import type { ColumnValueType } from '../fieldTypes';
import { baseEntityFieldTypes } from './base';

export const receiptFieldTypes: Readonly<Record<keyof Receipt, ColumnValueType>> = {
  AnzahlCont: 'integer',
  ArtAufteilung: 'string',
  Belegdatum: 'date',
  // `Buchdatum` ist in der API ein String, kein DateTime — die Filterzeile filtert als Text.
  Buchdatum: 'string',
  DL: 'string',
  GesamtbetragNetto: 'number',
  GesamtbetragNettoEuro: 'number',
  Kurs: 'number',
  Rechnungsart: 'string',
  Rechnungsnummer: 'string',
  Rechnungszuordnung_Container_Bestellposition_BuchungsperiodeWare: 'number',
  Rechnungszuordnung_Container_Bestellposition_SageBuchungDatum: 'date',
  Wkz: 'string',
  Zuordnungen: 'string',
  ...baseEntityFieldTypes,
};
